import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import report from '@/components/report'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/report',
      name: 'report',
      component: report
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js